import { ButtonData } from "./components/wordpress/types_and_parser/extra_types.mod"
import { TokenMemo } from "./components/public_site/custom_pages/types.mod"
import { mkWidget, Widget, Option } from "widgets-for-react"
import { Map } from "immutable"

export function toRelativeUrl(url: string): string {
  return url.replace(`${window.location.protocol}//${window.location.host}`, '')
}

export function urlIsExternal(url: string): boolean {
  return url.startsWith('http') && !url.startsWith(`${window.location.protocol}://${window.location.host}`)
}

export function createButtonData(text: string, url: string): ButtonData {
  return { text: unescapeHTML(text), url: url }
}

export type ViewPortSize = 'mobile' | 'tablet' | 'desktop'

export type LoadState<T> = {
  kind: 'loading'
} | {
  kind: 'error'
  errors: {
    [key: string]: string
  }
} | {
  kind: 'loaded'
  data: Option<T>
}


export function resizeImage(url: string, width: number, height: number): string {
  // Implement resize
  return url;
}

export function upperCaseFirst(text: string): string {
  return text ? text.substring(0, 1).toUpperCase() + text.substring(1) : ''
}

const escapeChars = { lt: '<', gt: '>', quot: '"', apos: "'", amp: '&' };

export function unescapeHTML(str: string) {//modified from underscore.string and string.js
  return str.replace(/\&amp;/g, '&')
  .replace(/\&([^;]+);/g, function (entity, entityCode) {
    var match;

    if (entityCode in escapeChars) {
      return escapeChars[entityCode];
    } else if (match = entityCode.match(/^#x([\da-fA-F]+)$/)) {
      return String.fromCharCode(parseInt(match[1], 16));
    } else if (match = entityCode.match(/^#(\d+)$/)) {
      return String.fromCharCode(~~match[1]);
    } else {
      return entity;
    }
  });
}

export function safeGet(tokenMemo: TokenMemo, key1: string, key2: string) {
  if (!tokenMemo.has(key1))
    return ''
  if (!tokenMemo.get(key1).has(key2))
    return ''
  return tokenMemo.get(key1).get(key2)
}

export interface SimpelPage<T> {
  items: T[]
  total_pages: number
  page_size: number
  current_page: number
  total_items: number

}

export interface SimpelPageMap<K, T> {
  items: Map<K, T>
  total_pages: number
  page_size: number
  current_page: number
  total_items: number
}

export const MapPage = <K, T>(_map: Map<K, T>, _total_pages: number, _total_items: number, _current_page: number = 1, _page_size: number = 15): SimpelPageMap<K, T> => ({
  current_page: 1,
  items: _map,
  page_size: _page_size,
  total_pages: _total_pages,
  total_items: _total_items,
})

export const fromJSX = <o,>(w: (cont: (_: o) => void) => JSX.Element): Widget<o> => mkWidget({ run: w, })

export const visit_option = <a, b>(option: Option<a>) => (onSome: (v: a) => b, onNone: () => b): b =>
  option.v.kind == 'r' ? onSome(option.v.v) : onNone()  


// Sample format: 09/22/2022 12:00 am
export const pretty_date = (date: string) => {
  if (date == undefined) return ""
  let parts = date.split('/')
  let day = parts[1]
  let month = parts[0]
  let rest = parts[2]
  return `${day}/${month}/${rest}`
}

export function removeLinksFromString(text: string): string {
  const regex = /(\b\w+:\/\/|www\.)\S+/gi;
  return text.replace(regex, '');
}

export function map_language (lang: string): string {
  if (lang == "be-nl") return "nl"
  if (lang == "be-fr") return "fr"
  return lang
}